import { DealMediaTypeEnum } from '../gql/generated/graphql';

// Safely convert to DealMediaTypeEnum[]
const DEAL_MEDIA_TYPE_VALUE_SET = new Set<string>(Object.values(DealMediaTypeEnum));
const isDealMediaTypeEnum = (value: string): value is DealMediaTypeEnum =>
  DEAL_MEDIA_TYPE_VALUE_SET.has(value);
export const toDealMediaTypeArray = (enumObject: Record<string, string>): DealMediaTypeEnum[] =>
  Object.values(enumObject).filter(isDealMediaTypeEnum);
